import { GetCardSecretsByIdResponse } from "@/types/cards.type";
import { apiService } from "../services/api";

export const getCards = async () => {
  const res = apiService.get("/cards");
  return res;
};

export const getCardSecretsById = async ({
  cardId,
  clientPublicKey,
  otp,
}: {
  cardId: string;
  clientPublicKey: string;
  otp: string;
}): Promise<GetCardSecretsByIdResponse> => {
  const response = await apiService.post(`/cards/${cardId}/secrets`, {
    clientPublicKey,
    otp,
  });

  return response;
};
